module.exports = __webpack_public_path__ + "img/upcoming-events-empty.dcf126f3.svg";